import { render, staticRenderFns } from "./KifuTournament.vue?vue&type=template&id=79e19e62&scoped=true&"
import script from "./KifuTournament.vue?vue&type=script&lang=js&"
export * from "./KifuTournament.vue?vue&type=script&lang=js&"
import style0 from "./KifuTournament.vue?vue&type=style&index=0&id=79e19e62&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79e19e62",
  null
  
)

export default component.exports